import { MSerializers } from "@legacy-megarax/serializers";

export type CustomerReference = { uuid: string };
export type PriceListReference = { uuid: string };

export const customerReferenceSerializer = MSerializers.object<CustomerReference>({
  uuid: MSerializers.uuid(),
});

export const priceListReferenceSerializer = MSerializers.object<PriceListReference>({
  uuid: MSerializers.uuid(),
});
